import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonGroup, Button, Tooltip } from "@mui/material";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useRefreshInterval } from "../contexts/RefreshIntervalContext";

const IntervalSelector = ({ sx = {} }) => {
  const { t } = useTranslation();
  const { interval, setInterval, isRunning, toggleRunning } =
    useRefreshInterval();

  const handleIntervalChange = (newInterval) => {
    setInterval(newInterval);
  };

  return (
    <ButtonGroup
      size="small"
      aria-label="refresh interval selector"
      sx={{ ...sx }}
    >
      <Tooltip
        title={
          isRunning ? t("intervalSelector.pause") : t("intervalSelector.resume")
        }
      >
        <Button
          variant={isRunning ? "outlined" : "contained"}
          onClick={toggleRunning}
          color={isRunning ? "primary" : "error"}
        >
          {isRunning ? (
            <PauseIcon fontSize="small" />
          ) : (
            <PlayArrowIcon fontSize="small" />
          )}
        </Button>
      </Tooltip>

      <Tooltip title={t("intervalSelector.seconds", { count: 15 })}>
        <Button
          variant={interval === 15 && isRunning ? "contained" : "outlined"}
          onClick={() => handleIntervalChange(15)}
          disabled={!isRunning}
        >
          15s
        </Button>
      </Tooltip>

      <Tooltip title={t("intervalSelector.seconds", { count: 30 })}>
        <Button
          variant={interval === 30 && isRunning ? "contained" : "outlined"}
          onClick={() => handleIntervalChange(30)}
          disabled={!isRunning}
        >
          30s
        </Button>
      </Tooltip>

      <Tooltip title={t("intervalSelector.seconds", { count: 60 })}>
        <Button
          variant={interval === 60 && isRunning ? "contained" : "outlined"}
          onClick={() => handleIntervalChange(60)}
          disabled={!isRunning}
        >
          60s
        </Button>
      </Tooltip>
    </ButtonGroup>
  );
};

export default IntervalSelector;
